export class LocalStorageHelper {

    static saveState(state) {
        try {
            localStorage.setItem(STORED_FIELDS.STATE, JSON.stringify(state));
        } catch (error) {
            console.error("Error saving state to localStorage", error);
        }
    }

    static combineState(state) {
        try {
            const currentState = LocalStorageHelper.loadState() || {};
            const combinedState = {
                ...currentState,
                ...state,
            };
            LocalStorageHelper.saveState(combinedState);
        } catch (error) {
            console.error("Error combining state to localStorage", error);
        }
    }

    static loadState() {
        try {
            const serializedState = localStorage.getItem(STORED_FIELDS.STATE);
            if (serializedState === null){
                return undefined;
            }
            return JSON.parse(serializedState);
        } catch (error) {
            console.error("Error loading state from localStorage", error);
            return undefined;
        }
    }

    static removeState() {
        try {
            localStorage.removeItem(STORED_FIELDS.STATE);
        } catch (error) {
            console.error("Error removing state from localStorage", error);
        }
    }

    // With storage blocked (e.g. third-party/site data blocked in the browser)
    // this returns null and the caller mints a per-session uid, so the app can
    // still boot instead of throwing a SecurityError at startup.
    static loadMachineUid() {
        try {
            return localStorage.getItem(STORED_FIELDS.MACHINE_UID);
        } catch (error) {
            console.error("Error loading machine uid from localStorage", error);
            return null;
        }
    }

    static saveMachineUid(uid) {
        try {
            localStorage.setItem(STORED_FIELDS.MACHINE_UID, uid);
        } catch (error) {
            console.error("Error saving machine uid to localStorage", error);
        }
    }

    // Maps an Everou device bluetoothId to the opaque Web Bluetooth device id
    // (BluetoothDevice.id), so we can reconnect silently via getDevices()
    // instead of parsing the advertised name (which is missing on devices that
    // show up as "Unknown or Unsupported Device" in the chooser).
    static loadBleDeviceIds() {
        try {
            const serialized = localStorage.getItem(STORED_FIELDS.BLE_DEVICE_IDS);
            return serialized ? JSON.parse(serialized) : {};
        } catch (error) {
            console.error("Error loading BLE device ids from localStorage", error);
            return {};
        }
    }

    static saveBleDeviceId(bluetoothId, webBluetoothDeviceId) {
        if (!bluetoothId || !webBluetoothDeviceId)
            return;
        try {
            const map = LocalStorageHelper.loadBleDeviceIds();
            map[bluetoothId] = webBluetoothDeviceId;
            localStorage.setItem(STORED_FIELDS.BLE_DEVICE_IDS, JSON.stringify(map));
        } catch (error) {
            console.error("Error saving BLE device id to localStorage", error);
        }
    }
}

const STORED_FIELDS = {
    MACHINE_UID: 'machine_uid',
    STATE: 'state',
    BLE_DEVICE_IDS: 'ble_device_ids',
};
